// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LLVum","tabsBox":"styles_tabsBox__hwV2q","createButton":"styles_createButton__JwZSd"};